export class SaveCopyMemo {
  static readonly type = '[Copy memo] SaveCopyMemo';
  constructor(public payload: any) {}
}
